import {connect} from 'react-redux';
import classNames from 'classnames';

import {gettext} from 'topmeteo/utils/i18n';
import {showShopPopUp} from 'topmeteo/general/actionCreators';
import {Types} from 'topmeteo/general/components/ShopPopUp/utils';

import {changeLocation, toggleFavourite, deleteLocation} from '../../actionCreators';

const DeleteLabel = gettext('Delete location');

const className = isFavourite => classNames(
    'mark-favorite',
    'icon-favourite',
    {none: isFavourite === false},
);

const LocationItem = ({name, isSelected, isFavourite, isUnavailable, onToggle, onClick, onDelete}) => (
    <li className={classNames({unavailable: isUnavailable})}>
        <strong className={className(isFavourite)} onClick={onToggle} />
        <span className="change-location" onClick={onClick}>{name}</span>
        {isSelected === false /* the current location couldn't be deleted */ && (
            <strong className="mark-favorite icon-trash-empty" title={DeleteLabel} onClick={onDelete} />
        )}
    </li>
);

const mapDispatchToProps = (dispatch, {id, name, isAnonymous, isUnavailable}) => {
    const prevent = event => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handler = actionCreator => event => {
        prevent(event);
        dispatch(actionCreator(id));
    };

    const shopPopUp = event => {
        prevent(event);
        dispatch(showShopPopUp(Types.Location, {title: name}))
    };

    return {
        onClick: isUnavailable ? shopPopUp : () => dispatch(changeLocation(id)),
        onToggle: isAnonymous ? null : handler(toggleFavourite),
        onDelete: isAnonymous ? null : handler(deleteLocation),
    };
};

export default connect(undefined, mapDispatchToProps)(LocationItem);
